"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTranslations = void 0;

var defaultTranslations = function defaultTranslations(isNonUkUser) {
  var postcode = isNonUkUser ? "Postal / Zip Code" : "Post code";
  var county = isNonUkUser ? "State / Province" : "County";
  return {
    firstName: "First name",
    lastName: "Last name",
    personalDetails: "Personal",
    personalDetailsSubtitle: "A few contact details",
    contactDetails: "Address",
    contactDetailsSubtitle: isNonUkUser ? "Optional" : "Where you are billed",
    mobileNumber: "Phone number",
    mobileNumberVerified: "Phone number verified",
    addressLine: "Address line 1",
    addressLine2: "Address line 2",
    city: "City",
    postcode: postcode,
    county: county,
    profile: "Profile",
    error: "error",
    saved: "saved",
    saveChanges: "Save changes",
    changePin: "Change pin",
    changePassword: "Change password",
    verifyMobile: "Verify phone number",
    invalid: "invalid",
    logout: "Logout",
    takeABreak: "Take a break",
    selfExclusion: "Self exclusion",
    imageUpdated: "Image updated",
    openWallet: "Open your wallet",
    contactPermission: "Contact Permission",
    pushNotification: "Push Notification",
    sms: "SMS",
    email: "Email",
    confirmMarketing: "Yes, I would like to receive personal offers from TOTO by email",
    optInCheckAll: "Confirm consent for the above marketing mediums",
    optInConsent: "Where you have given consent to receive marketing from Low6 or our associates, we may use your personal details to identify products and services which may be of interest to you. You can update your preferences at any time from your account settings.",
    optInMarketing: "Opting in to marketing will allow us to notify you of exclusive offers, promotions and bonuses."
  };
};

exports.defaultTranslations = defaultTranslations;